import React from 'react';
import { Tooltip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';

// Indicates who absorbs a fee on a payout/withdrawal row.
// `payer` is 'creator' | 'me' (client) | anything else (renders nothing).
export default function FeePayerIcon({ payer, size = 14 }) {
  if (!payer) return null;
  const isCreator = payer === 'creator';
  const isClient = payer === 'me' || payer === 'client';
  if (!isCreator && !isClient) return null;
  const Icon = isCreator ? PersonIcon : BusinessIcon;
  const label = isCreator ? 'Creator pays' : 'Client pays';
  return (
    <Tooltip title={label} arrow>
      <Icon sx={{ fontSize: size, ml: 0.25, verticalAlign: 'middle', opacity: 0.7 }} />
    </Tooltip>
  );
}
